import { AxiosResponse } from "axios";
import { all, call, put, takeEvery } from "redux-saga/effects";

import * as actions from "./action";
import * as types from "./types";
import * as services from "./service";
import * as alert from "../alert/actions";
import * as actionTypes from "./actionTypes";

function* postExtJobSchedulesSaga(action: types.PostExtJobSchedulesRequest) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IExtJobScheduleSuccess | types.IApiError> = yield call(services.postExtJobschedules, action.payload);
        if (response.status === 201) {
            let dataPayload = response.data as types.IExtJobScheduleSuccess;
            yield put(
                actions.postExtJobSchedulesSuccess({
                    dbExtStatus: dataPayload
                })
            );
            yield put(alert.enqueueSnackbar({ message: `Time based trigger successful. Timestamp: ${timestamp}`, options: { variant: "success" } }));
        }

        //Show IApiError
        if (response.status !== 201) {
            let apiError = response.data as types.IApiError;
            let errmsg = `StatusCode:${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}. Timestamp: ${timestamp}`;
            yield put(
                alert.enqueueSnackbar({
                    message: errmsg,
                    options: { variant: "error" },
                })
            );
            yield put(
                actions.postExtJobSchedulesFailure({
                    error: apiError,
                })
            );
        }
    } catch (e: any) {
        yield put(
            actions.postExtJobSchedulesFailure({
                error: e.message,
            })
        );
    }
}

// Put Job Schedules Extractor
function* putJobSchedulesSaga({ jobId, payload }: types.PutJobSchedulesRequest) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IPutJobSchedulesSuccess | types.IApiError> = yield call(services.putJobSchedulesdata, jobId, payload);

        if (response.status === 204) {
            let dataPayload = response.data as types.IPutJobSchedulesSuccess;
            yield put(
                actions.putExtJobSchedulesSuccess({
                    putJobSchedules: { success: true },
                })
            );
            let successMsg = `The job schedule was successfully edited. Job ID: ${jobId}. Timestamp: ${timestamp}`;
            yield put(alert.enqueueSnackbar({ message: successMsg, options: { variant: "success" } }));
        }

        if (response.status !== 204) {
            let apiError = response.data as types.IApiError;
            let errMsg = `StatusCode: ${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}. Timestamp: ${timestamp}`;
            yield put(alert.enqueueSnackbar({ message: errMsg, options: { variant: "error" } }));

        }
    } catch (e: any) {
        yield put(
            actions.putExtJobSchedulesFailure({
                error: e,
            })
        );
    }
}


function* deleteJobSchedulesSaga(action: types.DeleteJobSchedulesRequest) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IDeleteJobSchedulesSuccess | types.IApiError> = yield call(services.deleteJobSchedules, action.params);

        if (response.status === 204) {
            yield put(
                actions.deleteExtJobSchedulesSuccess({
                    success: true
                })
            );
            yield put(alert.enqueueSnackbar({ message: `The time based trigger was successfully deleted. Timestamp: ${timestamp}`, options: { variant: "success" } }));

        }

        //Show IApiError
        if (response.status !== 204) {
            let apiError = response.data as types.IApiError;
            let errmsg = `StatusCode:${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}. Timestamp: ${timestamp}`;
            yield put(alert.enqueueSnackbar({ message: errmsg, options: { variant: "error" } }));
        }

    } catch (e: any) {
        yield put(
            actions.deleteExtJobSchedulesFailure({
                error: e,
            })
        );
    }
}

/*
  Watcher saga - intercept the action fired from view
  Starts worker saga on latest dispatched `FETCH_ACCESSCONTROL_REQUEST` action.
  Allows concurrent increments.
*/
function* extJobSchedulesSaga() {
    yield takeEvery(actionTypes.POST_EXTJOBSCHEDULES_REQUEST, postExtJobSchedulesSaga);
}

function* deleteJobSchedules() {
    yield takeEvery(actionTypes.DELETE_EXTJOBSCHEDULES_REQUEST, deleteJobSchedulesSaga);
}

function* editJobSchedulesSaga() {
    yield takeEvery(
        actionTypes.PUT_EXTJOBSCHEDULES_REQUEST,
        putJobSchedulesSaga
    );
}

function* jobSchedulesSaga() {
    yield all([
        extJobSchedulesSaga(),
        deleteJobSchedules(),
        editJobSchedulesSaga(),
    ])
}

export default jobSchedulesSaga;